import { handleError } from './Actions'
import { put, fetch } from '../../calculator/lib/xhr'
import { ActionTypes as types } from '../constants'
import * as Actions from './Actions'

export function changeUnilateralName(name) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_NAME,
    data: { name },
  }
}

export function changeUnilateralFirstName(unilateralFirstName) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_FIRST_NAME,
    data: { unilateralFirstName },
  }
}

export function changeUnilateralLastName(unilateralLastName) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_LAST_NAME,
    data: { unilateralLastName },
  }
}

export function changeUnilateralCountryCode(countryCode) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_COUNTRY_CODE,
    data: { countryCode },
  }
}

export function resendMail(transactionId) {
  return dispatch => {
    dispatch({
      type: types.UNILATERAL.RESEND_MAIL_STATUS,
      data: { status: 'processing' },
    })
    const url = '/myaccount/transfer/resend-mail'
    const params = { transactionId }
    return put(url, params)
      .then(resp => {
        if (resp.data.sendNotification && resp.data.sendNotification.status) {
          dispatch({
            type: types.UNILATERAL.RESEND_MAIL_STATUS,
            data: { status: 'success' },
          })
          return resp.body.sendNotification
        }

        dispatch({
          type: types.UNILATERAL.RESEND_MAIL_STATUS,
          data: { status: 'initial' },
        })

        return { status: false }
      })
      .catch(handleError(dispatch))
  }
}

export function resolveUserDCContingency(
  action,
  handleSubmit,
  fundingOptionId,
  firstName,
  lastName
) {
  const url = `/myaccount/transfer/send/user-dc-contingency`
  const payload = {
    fundingOptionId,
    action,
    firstName,
    lastName,
  }

  return async dispatch => {
    dispatch({ type: types.TRANSACTION.RESOLVE_USER_DC_CONTINGENCY })
    await fetch(url, payload)
      .then(response => {
        if (response && response.isUserDCSuccess) {
          // Re-submit to proceed with transaction
          if (handleSubmit) {
            handleSubmit(
              { preventDefault: () => {} },
              { isUserDCResolved: true }
            )
          }
        }
      })
      .catch(err => {
        dispatch(Actions.showError(err))
      })
  }
}
